var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPhonePrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-phone 1",
    clipPath: "url(#clip0_3630_4135)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.3322 8.32C9.61822 7.70882 8.89166 7.33742 8.18673 7.9486L7.76486 8.31639C7.45656 8.58502 6.88325 9.83622 4.6675 7.28514C2.45176 4.73947 3.76966 4.34283 4.07976 4.07781L4.50344 3.70822C5.20476 3.09704 4.93974 2.32721 4.43313 1.53394L4.12844 1.05437C3.62002 0.264708 3.06474 -0.254523 2.36161 0.354852L1.9812 0.688386C1.6693 0.913747 0.800313 1.65113 0.589375 3.05016C0.335169 4.72865 1.13745 6.65233 2.97099 8.7617C4.80272 10.8729 6.59839 11.933 8.29671 11.9149C9.70837 11.8987 10.5629 11.1415 10.8298 10.8657L11.2102 10.5321C11.9133 9.92276 11.477 9.30077 10.7613 8.68959L10.3322 8.32Z",
    fill: "#735BF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3630_4135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhonePrimary);
export default __webpack_public_path__ + "static/media/iconPhonePrimary.772d58ef5a96afb1ae70e44ccd7c9766.svg";
export { ForwardRef as ReactComponent };